<div class="task-view-files__header">
  <div class="task-view-files__title">Файлы</div>
  <i class="icon-arrow-down task-view-files__context-icon" (click)="toggleMenu()"></i>
  @if (isShowMenu) {
    <ux-context-menu
      class="preview-image__context-menu"
      (clickOutside)="onClose()"
      [delayClickOutsideInit]="true"
      (click)="onClose()"
    >
      <ux-context-menu-item
        menu1
        icon="icon-plus-circle"
        name="Добавить файл"
        [isSelectFile]="true"
        (onSelectFile)="onFileUpload.emit($event)"
      ></ux-context-menu-item>
      <!--<ux-context-menu-item menu1 icon="icon-download" name="Скачать все"></ux-context-menu-item>-->
      <!--<ux-context-menu-item menu1 icon="icon-question" iconSize="13" name="Отправить на почту"></ux-context-menu-item>-->
      <!--<ux-context-menu-item menu1 icon="icon-trash" name="Удалить все"></ux-context-menu-item>-->
    </ux-context-menu>
  }
</div>

<div class="task-view-files__items">
  @for (image of filesList | filterBy: { isImage: true }; track image) {
    <ux-preview-image [image]="image" class="task-view-files__item" (deleteImage)="onDeleteFile($event)">
    </ux-preview-image>
  }

  @for (image of loadingFilesList; track image) {
    <ux-upload-image
      [image]="image"
      (onDelete)="onStopUploadAndDeleteFile(image)"
      class="task-view-comments-form__file-item"
    >
    </ux-upload-image>
  }

  <div class="task-view-files__select">
    <input type="file" [multiple]="true" (change)="onFileUpload.emit($event.target)" />
    <i class="icon-plus task-view-files__icon-file"></i>
  </div>
</div>

<div class="task-view-files__items task-view-files__items_mt10 task-view-files__items_row">
  @for (file of filesList | filterBy: { isImage: false }; track file) {
    <ux-preview-file [file]="file" (deleteFile)="onDeleteFile($event)"></ux-preview-file>
  }
</div>
